import { localizationService } from '@shared-services/localization-service';
import React from 'react';
import strings from '../../../strings';
import { CalEventDataWithDisplayPrice } from '../../../types';
import { shouldShowFreePriceLabel } from '../../../utils';
import {
    Card,
    CardContent,
    EventDescription,
    EventDuration,
    EventSubTitle,
    EventTitle,
    MainContent,
} from '../common/styles';

interface EventCardProps {
    calEventData?: CalEventDataWithDisplayPrice;
    identifier: string;
    onSelect: (event: CalEventDataWithDisplayPrice) => void;
    showFreePrice?: boolean | null;
    isPaid: boolean;
}

const { str } = localizationService;

const EventCard: React.FC<EventCardProps> = ({
    identifier,
    calEventData,
    onSelect,
    showFreePrice,
    isPaid,
}) => {
    if (!calEventData) {
        return null;
    }

    const handleSelect = () => onSelect(calEventData);
    const showPriceSubtitle = isPaid || shouldShowFreePriceLabel(showFreePrice);
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleSelect();
        }
    };

    return (
        <Card
            role='listitem'
            onClick={handleSelect}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            data-auto={`event-card-${calEventData.slug}`}
            data-event-id={identifier}
            aria-label={`Select ${calEventData.title}, ${
                calEventData.lengthInMinutes
            } minutes${
                showPriceSubtitle ? `, ${calEventData.displayPrice}` : ''
            }`}
        >
            <CardContent>
                <MainContent>
                    <EventTitle data-auto='event-card-title'>
                        {calEventData.title}
                    </EventTitle>
                    {!!calEventData.description && (
                        <EventDescription data-auto='event-card-description'>
                            {calEventData.description}
                        </EventDescription>
                    )}
                    <EventDuration data-auto='event-card-duration'>
                        {str(strings.durationMinutes, {
                            duration: calEventData.lengthInMinutes.toString(),
                        })}
                    </EventDuration>
                </MainContent>
                {showPriceSubtitle && (
                    <EventSubTitle data-auto='event-card-price'>
                        {calEventData.displayPrice}
                    </EventSubTitle>
                )}
            </CardContent>
        </Card>
    );
};

export default EventCard;
